var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "circle_support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VCS",
    transform: "translate(-820.000000, -1010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_support",
    transform: "translate(820.000000, 1010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F54250",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.750000, 3.750000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.78409091,0.886363636 C5.38636364,0.886363636 6.68181818,2.18181818 6.68181818,3.78409091 C6.68181818,5.38636364 5.38636364,6.68181818 3.78409091,6.68181818 C2.18181818,6.68181818 0.886363636,5.38636364 0.886363636,3.78409091 C0.886363636,2.18181818 2.18181818,0.886363636 3.78409091,0.886363636 L3.78409091,0.886363636 Z M3.78409091,0.0340909091 C1.70454545,0.0340909091 0.0340909091,1.70454545 0.0340909091,3.78409091 C0.0340909091,5.86363636 1.70454545,7.53409091 3.78409091,7.53409091 C5.86363636,7.53409091 7.53409091,5.86363636 7.53409091,3.78409091 C7.53409091,1.70454545 5.86363636,0.0340909091 3.78409091,0.0340909091 L3.78409091,0.0340909091 L3.78409091,0.0340909091 Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.363636, 1.363636)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07954545,1.26136364 L2.07954545,0.204545455 C1.15909091,0.340909091 0.409090909,1.05681818 0.238636364,1.97727273 L1.29545455,1.97727273 C1.43181818,1.67045455 1.70454545,1.39772727 2.07954545,1.26136364 L2.07954545,1.26136364 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54545455,2.01136364 L4.60227273,2.01136364 C4.43181818,1.09090909 3.68181818,0.375 2.76136364,0.238636364 L2.76136364,1.29545455 C3.10227273,1.39772727 3.40909091,1.67045455 3.54545455,2.01136364 L3.54545455,2.01136364 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76136364,3.54545455 L2.76136364,4.60227273 C3.71590909,4.46590909 4.5,3.68181818 4.60227273,2.69318182 L3.54545455,2.69318182 C3.47727273,3.10227273 3.17045455,3.44318182 2.76136364,3.54545455 L2.76136364,3.54545455 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26136364,2.69318182 L0.204545455,2.69318182 C0.340909091,3.68181818 1.09090909,4.43181818 2.04545455,4.60227273 L2.04545455,3.54545455 C1.67045455,3.44318182 1.36363636,3.10227273 1.26136364,2.69318182 L1.26136364,2.69318182 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSupport);
export default __webpack_public_path__ + "static/media/circle_support.01e7185b301c1c3fe1f617e4e176979d.svg";
export { ForwardRef as ReactComponent };